import React from "react";
import { useNavigate } from "react-router-dom";

const Links = ({ SVG, text, route }) => {
  const navigate = useNavigate();
  return (
    <div
      onClick={() => {
        navigate(route);
      }}
      style={{ margin: "12px 0rem", gap: "10px", cursor: "pointer" }}
      className="d-flex justify-content-between w-100 align-items-center"
    >
      <SVG />
      <div
        className="w-100 text-black"
        style={{
          fontFamily: "Inter",
          fontSize: "16px",
          fontWeight: "400",
          lineHeight: "100%",
          letterSpacing: "0%",
        }}
      >
        {text}
      </div>
    </div>
  );
};

export default Links;
